import type { ReactNode } from 'react'

const svg = (children: ReactNode) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    {children}
  </svg>
)

export const NAV_ICONS = {
  '/': svg(
    <>
      <path d="M3 13h5l1.5 3h5L16 13h5" />
      <path d="M5 5h14l2 8v6H3v-6z" />
    </>,
  ),
  '/corpus': svg(
    <>
      <path d="M6 4h12v16l-6-4-6 4z" />
      <path d="M9.5 10l1.8 1.8L15 8" />
    </>,
  ),
  '/knowledge-base': svg(
    <>
      <path d="M4 5a2 2 0 0 1 2-2h13v16H6a2 2 0 0 0-2 2z" />
      <path d="M19 19H6" />
    </>,
  ),
  '/usage': svg(
    <>
      <path d="M4 20V10" />
      <path d="M10 20V4" />
      <path d="M16 20v-7" />
      <path d="M21 20H3" />
    </>,
  ),
  '/settings': svg(
    <>
      <path d="M4 7h9" />
      <path d="M18 7h2" />
      <circle cx="15.5" cy="7" r="2.2" />
      <path d="M4 17h5" />
      <path d="M13.5 17H20" />
      <circle cx="11" cy="17" r="2.2" />
    </>,
  ),
  '/ops': svg(
    <>
      <path d="M3 12h4l2-5 3 10 2.5-5H21" />
    </>,
  ),
} satisfies Record<string, ReactNode>

export type NavPath = keyof typeof NAV_ICONS
